export interface DtoInterface {
  id?: string | number;
  content?:any[];
}
